// GOOD TO KNOW
// ------------
// Atlaskit DatePicker has two date formats:
// 1. YYYY/MM/DD which user sees on the screen
// 2. YYYY-MM-DD which DatePicker passes to the onChange callback (ISO format)
//
// Sometimes Atlaskit doesn't convert user-input date (YYYY/MM/DD) to the ISO format.
// It happens when some action gets dispatched before DatePicker receives blur event.
// So we fix it here by replacing `/` with `-`.

import format from 'date-fns/format';
import getTime from 'date-fns/getTime';
import isValid from 'date-fns/isValid';
import parseISO from 'date-fns/parseISO';
import startOfToday from 'date-fns/startOfToday';

export const atlasKitToISODateFormat = (dateStr?: string): string => {
	if (dateStr) {
		const date = parseISO(dateStr.replace(/\//g, '-'));
		if (isValid(date)) {
			return format(new Date(date), 'yyyy-MM-dd');
		}
	}
	return '';
};

export const ISOToAtlasKitDateFormat = (dateStr?: string): string => {
	if (dateStr) {
		const date = parseISO(dateStr);
		if (isValid(date)) {
			return format(new Date(date), 'yyyy/MM/dd');
		}
	}
	return '';
};

export const todayToAtlasKitDateFormat = (): string => format(startOfToday(), 'yyyy/MM/dd');

export const isAtlasKitDateValid = (dateStr: string): boolean => {
	if (dateStr) {
		return isValid(parseISO(dateStr.replace(/\//g, '-')));
	}
	return false;
};

// if date is empty then it has to be set to null to clear it on backend
export const atlasKitToServerDateFormat = (dateStr?: string | null): string | null => {
	let dateISO;
	if (dateStr && isAtlasKitDateValid(dateStr)) {
		dateISO = atlasKitToISODateFormat(dateStr);
	}
	return dateISO || null;
};

export const isoToTimestamp = (dateStr: string): number | undefined => {
	const date = parseISO(dateStr);
	if (isValid(date)) {
		return getTime(date);
	}
	return undefined;
};

export const localisedDateFormat = {
	year: 'numeric',
	month: 'short',
	day: '2-digit',
} as const;
